import ApiHelper from '../helpers/ApiHelper';

class ErrorService {
    static reportErrorFromReact(message, errorStack, componentStack) {
        return ApiHelper.postJSON('/api/logging/JavascriptError/', {
            Message: JSON.stringify(message),
            ErrorStack: JSON.stringify(errorStack),
            ComponentStack: JSON.stringify(componentStack)
        });
    }

    static reportErrorFromRequest(error) {
        const errorDetails = {
            message: error.message,
            status: error.response?.status,
            statusText: error.response?.statusText,
            data: error.response?.data,
            url: error.config?.url,
            method: error.config?.method,
            cause: error.cause ? {
                message: error.cause.message,
                code: error.cause.code,
                stack: error.cause.stack
            } : undefined
        };
        
        return ApiHelper.postJSON('/api/logging/RequestError/', {
            Message: JSON.stringify(errorDetails)
        });
    }
}

export default ErrorService;
